<template>
  <div class="mb-2">
    <aha-checkbox
      @change="handleEnableCopySlideNote"
      v-model="presentation.enableCopySlideNote"
      :disabled="isDisableEditPresentation"
    >
      <span>
        {{ $i18nPresenter.t('Include slide notes') }}
        <AhaSvg
          class="mb-1 ml-1 text-secondary-20"
          name="question"
          v-tooltip="$i18nPresenter.t('Receiver can see your notes when they copy this presentation to their account')"
        />
      </span>
    </aha-checkbox>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PresentationApi from '@/api/presentation'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {
  },
  props: {
    presentation: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
    from: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
  },
  methods: {
    handleEnableCopySlideNote() {
      if (this.from === 'SideCenterShareSlides') {
        Utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Share menu > Share slides > Include slide note',
          !!this.presentation.enableCopySlideNote,
          null,
          {
            presentationId: this.presentation.id,
            userId: this.currentUser.id,
            isPresentationOwner: this.presentation.userId === this.currentUser.id,
          },
        )
      }
      PresentationApi.patchPresentation(this.presentation.id, {
        enableCopySlideNote: this.presentation.enableCopySlideNote,
      })
      if (!this.$store.state.presentation.id) {
        if (this.presentation.enableCopySlideNote) {
          Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Share > Enable copy slide note')
        } else {
          Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Share > Disable copy slide note')
        }
        return
      }
      if (this.presentation.enableCopySlideNote) {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Enable copy slide note')
      } else {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Disable copy slide note')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
